/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Typography,
  IconButton,
  Button,
  Grid,
  Paper,
  Link,
  Modal,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import { ArrowBack, Notifications, AccountCircle, MoreVert, Pause } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg';
import { useCallback, useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';
import { useGoogleMaps } from 'packages/novous_web/src/context/GoogleMapContext';
import eye from 'packages/novous_web/src/assets/icons/full-screen-icon.svg';
import LiveFeedModal from '../../../Reports/components/LiveFeed';
import { PlayArrow } from '@mui/icons-material';
import Comment from 'packages/novous_web/src/assets/icons/Comment.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import InputField from 'packages/novous_web/src/common/components/InputField';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import ShareFootageModal from 'packages/novous_web/src/common/components/ShareFootageModal';
import MapPreview from '../../../Home/components/MapPreview';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import axiosInstance from '../../../../../api/apiClient';
import VideoOverlay from '../../../Trips/componenets/VideoOverlay';
import useApiError from 'packages/novous_web/src/api/useApiError';
import BookIcon from 'packages/novous_web/src/assets/images/Book.svg';

type VideoPlayerProps = {
  controls?: boolean;
  duration?: number;
  playing?: boolean;
  cameraId?: string;
  deviceId?: string;
  sdVideo?: boolean;
  fullMode?: boolean;
  singleFullMode?: boolean;
  mlParams?: any;
};

interface AlertCardProps {
  driverName: string;
  vehicleNumber: string;
  dateTime: string;
  videoUrls: string[];
  deviceId?: string;
  warningSortKey?: string;
  onPlayIconClick?: (
    vehicleNumber: string,
    videoUrls: string[],
    deviceId?: string,
    warningSortKey?: string,
  ) => void;
}

const AlertCard: React.FC<AlertCardProps> = ({
  vehicleNumber,
  videoUrls,
  onPlayIconClick,
  deviceId,
  warningSortKey,
}) => {
  return (
    <>
      <div className="flex justify-center items-center absolute right-4 top-4 z-10">
        <div className="flex justify-between gap-2">
          <div className="flex gap-2 rounded-md bg-white p-1">
            <img
              src={eye}
              alt="play"
              className="w-6 h-6 cursor-pointer"
              onClick={() =>
                onPlayIconClick && onPlayIconClick(vehicleNumber, videoUrls, deviceId ?? '', warningSortKey)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

const VehicleAlertDetail: React.FC<VideoPlayerProps> = ({
  playing = true,
  duration = 0,
  controls = false,
  cameraId,
  deviceId,
  sdVideo,
  fullMode,
  singleFullMode,
  mlParams,
}) => {
  const NON_VIDEO_ALERTS = [
    'Continuous Driving',
    'Night Driving',
    'Geo Fence Alert',
    'Geofence Out Duration Exceeded',
    'Geofence Overspeed Violation',
  ];
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [overlayReady, setOverlayReady] = useState(false);
  const [playerSize, setPlayerSize] = useState({ width: 0, height: 0 });
  const [blurStatus, setBlurStatus] = useState<boolean>(false);
  const { user } = useAuth();
  const {
    data: vehicleAlertDetailsData,
    error: vehicleAlertDetailsError,
    loading: vehicleAlertDetailsLoading,
    fetchData: fetchVehicleAlertDetailsData,
  } = useAxios<any>(API_ENDPOINTS.alarm.VEHICLE_ALERT_DETAILS, 'POST');
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const [playingVideos, setPlayingVideos] = useState<Set<number>>(new Set());

  // Initialize video refs array
  const handlePlayVideo = async (index: number) => {
    const video = videoRefs.current[index];
    if (!video) return;

    try {
      if (video.paused) {
        // Only handle the clicked video, don't touch others
        await video.play();
        setPlayingVideos((prev) => new Set([...prev, index]));
      } else {
        video.pause();
        setPlayingVideos((prev) => {
          const newSet = new Set(prev);
          newSet.delete(index);
          return newSet;
        });
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.error('Video playback failed:', error);
      if (error.name === 'NotAllowedError') {
        // Try again with muted audio
        video.muted = true;
        await video.play();
        setPlayingVideos((prev) => new Set([...prev, index]));
      }
    }
  };
  const [videos, setVideos] = useState<any>();
  const [VideoReady, setVideoReady] = useState<boolean>(true);
  const navigate = useNavigate();
  const location = useLocation();
  const alertState = location.state || {};
  console.log('alertState', alertState);
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const [alert, setAlert] = useState<any>();
  const { data, error, loading, fetchData } = useAxios<any>(
    API_ENDPOINTS.alarm.VEHICLE_ALERT_COMMENT,
    'POST',
  );
  const { data: alertsEmailData, fetchData: fetchAlertsEmailData } = useAxios<any>(
    `${API_ENDPOINTS.alarm.SHARE_ALERT_DETAILS_EMAIL}`,
    'POST',
  );

  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const {
    data: coachingData,
    error: coachingError,
    loading: coachingLoader,
    fetchData: createCustomCoaching,
  } = useAxios<any>(`${API_ENDPOINTS.coaching.CUSTOM_DRIVER_COACHING}`, 'POST');
  const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({
    isOpen: false,
    tripId: '',
    vehicleId: '',
    deviceId: '',
    warningSortKey: '',
  });
  const [selected, setSelected] = useState(2);
  const [cameraView, setCameraView] = useState<'All' | '1 Cam' | '2 Cam' | '4 Cam'>('All');
  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({ isOpen: false, tripId: '', vehicleId: '', deviceId: '', warningSortKey: '' });
    setSelected(2);
  };
  useEffect(() => {
    if (alert?.comment) {
      setAlertComment(alert.comment);
    }
    fetchVehicleAlertDetailsData({
      fleetId: user?.customer_id,
      alertName: alertState.warningString || alertState.message,
      alertTime: convertTimestamp(alertState.date_time),
      vehicleId: alertState.vehicleId,
      vehicleGroup: alertState.vehicle_group,
    });
  }, [data]);
  const [modalOpen, setModalOpen] = useState(false);
  const handleClose = () => {
    setModalOpen(false);
  };
  const [alertComment, setAlertComment] = useState<string>('');
  const [openEmailModal, setOpenEmailModal] = useState(false);

  const handleOpenLiveFeed = (
    vehicleId: string,
    videoUrls: string[],
    cameraKey?: string,
    deviceId?: string,
    warningSortKey?: string,
  ) => {
    setIsLiveFeedOpen({
      isOpen: true,
      tripId: vehicleId,
      vehicleId: vehicleId,
      deviceId: alert?.device_id,
      warningSortKey: alert?.warningSortKey,
    });

    const cameraInfo = videoUrls.map((url) => {
      const fileName = url.split('/').pop()?.split('?')[0] || '';
      const segments = fileName.split('_');
      const cameraCode = segments[1] || 'Unknown';

      const cameraMapping: Record<string, string> = {
        '01': 'ADAS',
        '02': 'CAM3',
        '03': 'CAM4',
        '04': 'DMS',
      };
      const arr = Object.entries(cameraMapping);
      const ck =
        cameraKey === 'FCW'
          ? 'ADAS'
          : cameraKey === 'DSM'
          ? 'CAM3'
          : cameraKey === 'REAR_CAMERA'
          ? 'CAM4'
          : cameraKey === 'IN_CABIN'
          ? 'DMS'
          : cameraKey;

      const cameraName = cameraMapping[cameraCode] || 'Unknown';
      //  const cameraId = cameraMapping[cameraCode] || "Unknown";
      return { cameraId: cameraCode, cameraName, playBackUrl: url };
    });

    setLiveFeedCameraInfo(cameraInfo);
    setSelected(0);
  };
  const [alertMessage, setAlertMessage] = useState<string>('');
  const getCameraType = (url: string, cameraKey?: string) => {
    const fileName = url.split('/').pop()?.split('?')[0] || '';
    const segments = fileName.split('_');
    const cameraCode = segments[1] || 'Unknown';
    const cameraMapping: Record<string, string> = {
      '01': 'ADAS',
      '02': 'CAM3',
      '03': 'CAM4',
      '04': 'DMS',
    };
    const arr = Object.entries(cameraMapping);
    const ck =
      cameraKey === 'FCW'
        ? 'ADAS'
        : cameraKey === 'DSM'
        ? 'CAM3'
        : cameraKey === 'REAR_CAMERA'
        ? 'CAM4'
        : cameraKey === 'IN_CABIN'
        ? 'DMS'
        : cameraKey;

    const cameraName = cameraMapping[cameraCode] || 'Unknown';
    //  const cameraId = cameraMapping[cameraCode] || "Unknown";
    return { cameraId: cameraCode, cameraName, playBackUrl: url };
  };

  const handleCommentModalOpen = (alert: any) => {
    if (alert?.comment) {
      setAlertComment(alert?.comment);
    }
    setModalOpen(true);
  };

  console.log(overlayReady, 'overlayReady yashxx 258', !VideoReady);

  const getVideosToDisplay = async () => {
    try {
      let videoURLSs = alert?.videoUrls || [];

      if (!alert?.videoFileName) {
        console.log('No video file name available');
        return [];
      }

      if (videoURLSs.length === 0) {
        const response = await axiosInstance({
          url: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
          method: 'POST',
          data: {
            vehicleId: alert?.vehicleId,
            timestamp: alert?.warningSortKey.split('#')[1],
            alertType: alertState?.warningString || alertState?.message,
            fileNames: alert?.videoFileName,
            fleetId: user?.customer_id,
          },
          responseType: 'json',
        });

        videoURLSs = Array.isArray(response.data.data) ? response.data.data : [];
      }

      switch (cameraView) {
        case '1 Cam':
          return videoURLSs.slice(0, 1);
        case '2 Cam':
          return videoURLSs.slice(0, 2);
        case '4 Cam':
          return videoURLSs.slice(0, 4);
        case 'All':
        default:
          return videoURLSs;
      }
    } catch (error) {
      console.error('Error getting videos:', error);
      return []; // Return empty array on error
    }
  };
  const saveComment = () => {
    if (alertComment.trim() === '') {
      setAlertMessage('Please enter a comment');
      setAlertType('error');
      setAlertOpen(true);
      return;
    }
    fetchData({
      deviceId: alert?.device_id,
      comment: alertComment,
      sortKey: alert?.warningSortKey,
    });
    setModalOpen(false);
  };

  const handleTripReconstruction = useCallback(() => {
    if (alertState?.tripId) {
      // Use absolute path to ensure correct navigation
      navigate(`/trips/reconstruction/${alertState.tripId}`, {
        state: { vehicleId: alertState?.vehicleId, fromAlerts: true },
      });
      console.log('Navigating to trip reconstruction:', alertState.tripId);
    }
  }, [alertState, navigate]);

  function convertTimestamp(input: any): string {
    if (typeof input !== 'string') {
      console.warn('convertTimestamp: expected string, got', input);
      return '';
    }
    const parts = input.split('_');
    if (parts.length !== 6) {
      // fallback for ISO or other formats — just return it (or parse via Date)
      console.warn('convertTimestamp: unexpected format, got', input);
      return input;
    }
    const [year, month, day, hour, minute, second] = parts;
    // Now safe to pad
    const mm = month.padStart(2, '0');
    const dd = day.padStart(2, '0');
    const hh = hour.padStart(2, '0');
    const mi = minute.padStart(2, '0');
    const ss = second.padStart(2, '0');
    return `${year}-${mm}-${dd}:${hh}:${mi}:${ss}`;
  }

  useEffect(() => {
    if (alertState?.date_time) {
      fetchVehicleAlertDetailsData({
        fleetId: user?.customer_id,
        alertName: alertState.warningString || alertState.message,
        alertTime: convertTimestamp(alertState.date_time),
        vehicleId: alertState.vehicleId,
        vehicleGroup: alertState.vehicle_group,
      });
    }
  }, [user?.customer_id, alertState]);

  useEffect(() => {
    if (vehicleAlertDetailsData) {
      setAlert(vehicleAlertDetailsData?.data);
    }
  }, [vehicleAlertDetailsData]);

  const MapComponent = ({ lat, lng }: { lat: number; lng: number }) => {
    const { isLoaded } = useGoogleMaps();
    const [isHovered, setIsHovered] = useState(false);
    const [address, setAddress] = useState<string | null>(null);
    const [geocodeError, setGeocodeError] = useState<string | null>(null);

    useEffect(() => {
      if (!isLoaded) return;

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === 'OK') {
          if (results?.[0]) {
            setAddress(results[0].formatted_address);
            setGeocodeError(null);
          } else {
            setGeocodeError('No address found for this location');
          }
        } else {
          setGeocodeError('Reverse geocoding failed: ' + status);
        }
      });
    }, [lat, lng, isLoaded]);

    if (!isLoaded)
      return (
        <div className="h-64 bg-gray-100 flex items-center justify-center rounded-lg">Loading map...</div>
      );
    return (
      <GoogleMap
        zoom={15}
        center={{ lat, lng }}
        mapContainerClassName="w-full h-full rounded-lg"
        options={{
          streetViewControl: true,
          mapTypeControl: true,
          fullscreenControl: true,
        }}
      >
        <Marker
          position={{ lat, lng }}
          onMouseOver={() => setIsHovered(true)}
          onMouseOut={() => setIsHovered(false)}
        >
          {isHovered && (
            <InfoWindow
              position={{ lat, lng }}
              options={{
                pixelOffset: new window.google.maps.Size(0, -2),
                disableAutoPan: true,
                maxWidth: 450,
              }}
            >
              <div className="px-1 py-1 text-xs bg-white shadow-md rounded-sm">
                {address && <p className="truncate mb-1 font-medium">Address: {address}</p>}
                {geocodeError && <p className="text-red-500 text-xs">{geocodeError}</p>}
                <p className="truncate">
                  Date:{' '}
                  {alert?.date_time
                    ? new Date(
                        alert.date_time.replace(
                          /(\d{4})_(\d{2})_(\d{2})_(\d{2})_(\d{2})_(\d{2})/,
                          '$1-$2-$3T$4:$5:$6',
                        ),
                      )
                        .toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/,/g, '')
                    : 'N/A'}
                </p>
                <p className="truncate">Vehicle Reg No: {alert?.vehicleId}</p>
              </div>
            </InfoWindow>
          )}
        </Marker>
      </GoogleMap>
    );
  };
  useEffect(() => {
    (async () => {
      if (alert) {
        const videos = await getVideosToDisplay();
        setVideos(videos);
        videoRefs.current = videoRefs.current.slice(0, videos.length);
      }
    })();
  }, [alert]);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  console.log(alert, 'data-alert');
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);
  const handleEmailModalOpen = () => {
    setOpenEmailModal(true);
  };

  const handleEmailModalClose = () => {
    setOpenEmailModal(false);
  };

  const {
    data: mlParamsData,
    error: mlParamsError,
    loading: mlParamsLoading,
    fetchData: mlParamsRequestData,
  } = useApiError<any>(`${API_ENDPOINTS.videoBlur.BLUR_CROPPED_VIDEO}/${alertState?.device_id}`, 'GET');

  useEffect(() => {
    if (mlParamsError) {
      setToast({ open: true, message: 'Error while fetching ML Params', type: 'error' });
    }
  }, [mlParamsError]);

  useEffect(() => {
    if (blurStatus) {
      mlParamsRequestData(alertState?.device_id);
    }
  }, [blurStatus]);

  mlParams = mlParamsData;

  useEffect(() => {
    if (!overlayReady || !videoRefs.current[0]) return;

    const updateSize = () => {
      const video = videoRefs.current[0];
      if (video && video.readyState > 0) {
        // Check if video has loaded
        const rect = video.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          // Only update if valid dimensions
          setPlayerSize({ width: rect.width, height: rect.height });
        }
      }
    };

    updateSize(); // initial call

    const resizeObserver = new ResizeObserver(updateSize);
    if (videoRefs.current[0]) {
      resizeObserver.observe(videoRefs.current[0]);
    }
    const video = videoRefs.current[0];
    const handleLoadedMetadata = () => updateSize();
    video?.addEventListener('loadedmetadata', handleLoadedMetadata);

    return () => {
      resizeObserver.disconnect();
      video?.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, [overlayReady, videos]);

  console.log(playerSize, 'playerSize');
  useEffect(() => {
    if (!cameraId || cameraId !== 'IN-CABIN') {
      console.log('Making overlayReady true yashxx 507', true);

      setOverlayReady(true); // Default ready if no overlay is required
    }
  }, [cameraId]);

  useEffect(() => {
    if (videoRefs.current && overlayReady && playing) {
      videoRefs.current.forEach((video) => {
        if (video) {
          video.play().catch((error) => console.error('Video playback error:', error));
        }
      });
    }
  }, [overlayReady, playing]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement =
        document.fullscreenElement ||
        document.fullscreenElement ||
        document.fullscreenElement ||
        document.fullscreenElement;
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [isFullscreen]);

  const handleBlurStatus = (blurStatus: boolean) => {
    console.log('handleBlurStatus called');
    setVideoReady(blurStatus);
    setBlurStatus(blurStatus);
  };

  const [driverDialogOpen, setDriverDialogOpen] = useState(false);

  const redirectToDriverHistory = () => {
    if (!alert?.driverId || alert?.driverId === 'NA') {
      setDriverDialogOpen(true);
      return;
    } else {
      navigate(`/directories/drivers/${alert?.driverId}`);
    }
  };

  const driverDialogClose = () => {
    setDriverDialogOpen(false);
  };

  const createCustomDriverCoaching = async (alert: any) => {
    // if (!alertState?.driverId || alertState?.driverId === 'NA' || alertState?.driverId === null) {
    //   setToast({
    //     open: true,
    //     message: 'No Driver Id found for the Selected Vehicle.',
    //     type: 'error',
    //   });
    //   return;
    // }
    try {
      const response = createCustomCoaching({
        deviceId: alert?.device_id,
        warningSortKey: alert?.warningSortKey,
      });
      setAlertMessage('Driver Coaching created Successfully');
      setAlertType('success');
      setAlertOpen(true);
    } catch (error) {
      console.error('Error:', error);
      setAlertMessage('Error while creating Driver coaching');
      setAlertType('error');
      setAlertOpen(true);
    }
  };

  return (
    <>
      <Box className="min-h-screen p-4">
        {/* Back Link */}
        <div className="w-full">
          <button className="text-blue-600 font-medium flex items-center" onClick={() => navigate(-1)}>
            <ArrowBack className="mr-1" /> Back
          </button>
        </div>
        <div className=" w-full flex justify-between gap-4 xs:flex-col items-start my-8">
          <div className="max-w-max">
            <div className="dashboard-header-left">
              <div className="flex flex-col items-start">
                <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight="36px">
                  Alert Details
                </Typography>
              </div>
            </div>
          </div>
          <div className="flex gap-4 flex-wrap">
            <CustomIconButton
              icon={<img src={Comment} alt="Custom" width={26} height={26} />}
              text="Add Comment"
              background="transparent"
              outline={false} // Set to true if you want an outline
              onClick={() => handleCommentModalOpen(alert)}
            />
            <CustomIconButton
              icon={<img src={share} alt="Custom" width={26} height={26} />}
              text="Share Alert"
              background="transparent"
              outline={false} // Set to true if you want an outline
              onClick={() => handleEmailModalOpen()}
            />
            <CustomIconButton
              icon={<img src={reverse} alt="Custom" width={26} height={26} />}
              text="Trip Reconstruction"
              background="transparent"
              outline={false} // Set to true if you want an outline
              onClick={handleTripReconstruction}
            />
            <CustomIconButton
              // icon={<img src={call} alt="download" width={16} height={16} />}
              text="Driver History"
              background="transparent"
              variant="outlined"
              outline={true}
              onClick={redirectToDriverHistory}
            />
            <CustomIconButton
              icon={<img src={BookIcon} alt="download" width={16} height={16} />}
              text="Share Coaching"
              // background="transparent"
              variant="outlined"
              outline={true}
              onClick={() => createCustomDriverCoaching(alert)}
              // isDisabled={!alertState?.driverId || alertState?.driverId === 'NA' || alertState?.driverId === null}
            />
          </div>
        </div>
        {/* Main Content */}
        <div className="grid grid-cols-2 h-screen">
          <Paper className="p-4 rounded-lg max-h-screen overflow-y-auto">
            <Box className="mb-4 p-4 rounded-lg border">
              <Typography variant="h4" fontSize="18px" fontWeight={600} lineHeight="26px">
                General Details
              </Typography>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Name
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.warningString || alertState?.warningString}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Type
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px" color="red">
                    Critical
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Date
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.date_time
                      ? new Date(
                          alert.date_time.replace(
                            /(\d{4})_(\d{2})_(\d{2})_(\d{2})_(\d{2})_(\d{2})/,
                            '$1-$2-$3T$4:$5:$6',
                          ),
                        )
                          .toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                          .replace(/,/g, '') // Removes comma (e.g., "21 Mar 2025")
                      : 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Time
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.date_time
                      ? new Date(
                          alert.date_time.replace(
                            /(\d{4})_(\d{2})_(\d{2})_(\d{2})_(\d{2})_(\d{2})/,
                            '$1-$2-$3T$4:$5:$6',
                          ),
                        ).toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: true,
                        })
                      : 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Vehicle Speed
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {`${alert?.gpsSpeed} Km/h` || 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Route Name
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.routeName || 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Trip Name
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.tripName || 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Device Id
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.device_id || 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Trip Id
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.tripId || 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    CIS No
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.cisNo || 'N/A'}
                  </Typography>
                </Box>
              </div>
            </Box>
            <Box className="mb-4 p-4 rounded-lg border">
              <Typography variant="h4" fontSize="18px" fontWeight={600} lineHeight="26px">
                Vehicle Details
              </Typography>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Vehicle Reg No.
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.vehicleId || 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Depot Name
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.vehicle_group || 'N/A'}
                  </Typography>
                </Box>
              </div>
            </Box>
            <Box className="mb-4 p-4 rounded-lg border">
              <Typography variant="h4" fontSize="18px" fontWeight={600} lineHeight="26px">
                Driver Details
              </Typography>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Employee ID
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.driverId !== null ? alert?.driverId : 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Driver Name
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.driverName !== null ? alert?.driverName : 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography variant="h4" fontSize="14px" fontWeight={400} lineHeight="22px">
                    Driver Contact
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.phoneNumber || 'N/A'}
                  </Typography>
                </Box>
              </div>
            </Box>
            <Box className="mb-4 p-4 rounded-lg border">
              <Typography variant="h4" fontSize="18px" fontWeight={600} lineHeight="26px">
                Comments
              </Typography>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <Box className="mb-4">
                  <Typography
                    variant="h4"
                    fontSize="14px"
                    fontWeight={500}
                    lineHeight="20px"
                    color="text.secondary"
                  >
                    Comments
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.comment !== null ? alert?.comment : 'N/A'}
                  </Typography>
                </Box>
                <Box className="mb-4">
                  <Typography
                    variant="h4"
                    fontSize="14px"
                    fontWeight={500}
                    lineHeight="20px"
                    color="text.secondary"
                  >
                    Warning Status
                  </Typography>
                  <Typography variant="h4" fontSize="16px" fontWeight={600} lineHeight="22px">
                    {alert?.markWarningStatus === null || alert?.markWarningStatus === undefined
                      ? 'N/A'
                      : alert?.markWarningStatus === 'true' || alert?.markWarningStatus === true
                      ? 'True'
                      : 'False'}
                  </Typography>
                </Box>
              </div>
            </Box>
            <Box className="mb-4 p-4 rounded-lg border h-[500px]">
              {' '}
              {/* Increased height */}
              <Typography variant="h4" fontSize="18px" fontWeight={600} lineHeight="26px">
                Alert Location
              </Typography>
              {alert?.gpsLat && alert?.gpsLong ? (
                <div className="mt-4 h-full flex flex-col">
                  {' '}
                  {/* Added flex layout */}
                  <div className="flex-1">
                    {' '}
                    {/* This will make the map fill available space */}
                    <MapComponent lat={alert.gpsLat} lng={alert.gpsLong} />
                  </div>
                  <Typography variant="body2" className="mt-2 text-gray-600">
                    Latitude: {alert.gpsLat}, Longitude: {alert.gpsLong}
                  </Typography>
                </div>
              ) : (
                <Typography variant="body2" className="mt-4 text-gray-600">
                  Location data not available
                </Typography>
              )}
            </Box>
          </Paper>

          <Paper className="p-4 rounded-lg max-h-screen">
            <div className="flex justify-between items-center mb-4 h-[10%]">
              <Typography variant="h6" className="font-bold mb-4">
                Camera Footage
              </Typography>

              <Box className="flex flex-wrap gap-2 mb-4">
                {['All', 'ADAS', 'DMS', 'Cam 3', 'Cam 4'].map((btn) => (
                  <Button
                    key={btn}
                    variant={cameraView === btn ? 'contained' : 'outlined'}
                    onClick={() => setCameraView(btn as 'All' | '1 Cam' | '2 Cam' | '4 Cam')}
                  >
                    {btn}
                  </Button>
                ))}
              </Box>
            </div>

            {/* <Box className="space-y-4 h-[90%]">
            {getVideosToDisplay().length > 0 ? (
              getVideosToDisplay().map((url: string, index: number) => {
                return (
                  <Box key={index} className="p-3 rounded-lg h-[50%] flex flex-col gap-8 relative">
                    <Box className="flex justify-between items-center mb-2 absolute left-4 top-4">
                      <span className="bg-gray-200 px-2 py-1 rounded text-sm">
                        {getCameraType(url)}
                      </span>
                    </Box>
                    <AlertCard
                      key={alert?.device_id}
                      driverName={alert?.driverId || "NA"}
                      vehicleNumber={alert?.vehicleId}
                      dateTime={alert?.date_time}
                      videoUrls={alert?.videoUrls || []}
                      onPlayIconClick={handleOpenLiveFeed}
                    />
                    <Box
                      className="absolute inset-0 flex items-center justify-center cursor-pointer z-20"
                      onClick={() => handlePlayVideo(index)}
                    >
                      {!playingVideos.has(index) ? (
                        <PlayArrow
                          fontSize="large"
                          className="text-white bg-black/50 rounded-full p-2 hover:bg-black/70"
                          style={{ fontSize: '3rem' }}
                        />
                      ) : (
                        <Pause
                          fontSize="large"
                          className="text-white bg-black/50 rounded-full p-2 hover:bg-black/70"
                          style={{ fontSize: '3rem' }}
                        />
                      )}
                    

                    <video
                      ref={(el) => (videoRefs.current[index] = el)}
                      controls={false}
                      className="w-full h-full rounded-lg bg-black object-cover"
                      preload="auto"
                      muted={true}
                      playsInline
                      onClick={() => handlePlayVideo(index)}
                      onEnded={() => setPlayingVideos(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(index);
                        return newSet;
                      })}
                    >
                      <source src={url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box className="text-center p-8 rounded-lg">
                <Typography>No video footage available for this alert</Typography>
              </Box>
            )}
          </Box> */}
            <Box className="space-y-4 h-[90%]">
              {videos?.length > 0 ? (
                videos?.map((url: string, index: number) => (
                  <Box key={index} className="p-3 rounded-lg h-[50%] relative flex flex-col gap-8 relative">
                    <Box className="flex justify-between items-center mb-2 absolute left-4 top-4">
                      <span className="bg-gray-200 px-2 py-1 rounded text-sm">
                        {getCameraType(url).cameraName}
                      </span>
                    </Box>

                    <AlertCard
                      key={alert?.device_id}
                      driverName={alert?.driverId || 'NA'}
                      vehicleNumber={alert?.vehicleId}
                      dateTime={alert?.date_time}
                      videoUrls={alert?.videoUrls || []}
                      deviceId={alert?.device_id || ''}
                      warningSortKey={alert?.warningSortKey || ''}
                      onPlayIconClick={() => {
                        handleOpenLiveFeed(alert?.vehicleId, videos, alert?.device_id, alert?.warningSortKey);
                      }}
                    />
                    <Box
                      className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 w-16 h-16 flex justify-center items-center rounded-full"
                      sx={(theme) => ({
                        px: { xs: 1, sm: 2 },
                        textTransform: 'none',
                        fontWeight: 700,
                        boxShadow: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: theme.palette.primary.main,
                      })}
                      onClick={() => handlePlayVideo(index)}
                    >
                      {!playingVideos.has(index) ? (
                        <PlayArrow fontSize="large" className="text-white" style={{ fontSize: '3rem' }} />
                      ) : (
                        <Pause fontSize="large" className="text-white" style={{ fontSize: '3rem' }} />
                      )}
                    </Box>
                    {getCameraType(url).cameraId === '04' && (
                      <VideoOverlay
                        streamUrl={url}
                        deviceId={alert?.device_id}
                        customerId={alert?.customerId}
                        sdVideo={sdVideo}
                        fullMode={fullMode}
                        singleFullMode={singleFullMode}
                        mlParams={mlParams}
                        setBlurStatus={handleBlurStatus}
                        onOverlayReady={(value: boolean) => {
                          console.log('Making overlayReady true yashxx 203', value);
                          setOverlayReady(value);
                        }}
                        playerSize={playerSize}
                        tableBlur={true}
                      />
                    )}
                    {(overlayReady || !VideoReady) && (
                      <video
                        ref={(el) => (videoRefs.current[index] = el)}
                        controls={false}
                        className="w-full h-full rounded-lg bg-black object-cover"
                        preload="auto"
                        muted={true}
                        playsInline
                        onClick={() => handlePlayVideo(index)}
                        onEnded={() =>
                          setPlayingVideos((prev) => {
                            const newSet = new Set(prev);
                            newSet.delete(index);
                            return newSet;
                          })
                        }
                      >
                        <source src={url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </Box>
                ))
              ) : (
                <div className="flex h-full justify-center items-center text-center">
                  <Typography variant="body2" color="secondary" fontWeight={600} fontSize={36}>
                    {NON_VIDEO_ALERTS.includes(alertState?.warningString || alertState?.message)
                      ? 'No video available for this alert'
                      : 'Video is yet to be uploaded'}
                  </Typography>
                </div>
              )}
            </Box>
          </Paper>
        </div>
        <LiveFeedModal
          type="alert"
          alertName="Alert Evidence Video4"
          selectedCamera={selected}
          trip={isLiveFeedOpen}
          cameraInfo={liveFeedCameraInfo}
          isDash={true}
          open={isLiveFeedOpen.isOpen}
          onClose={handleLiveFeedClose}
          deviceId={alert?.device_id}
        />
        <Modal
          open={modalOpen}
          onClose={handleClose}
          aria-labelledby="add-comment-modal"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box
            sx={{
              width: 560,
              height: 472,
              p: 4,
              borderRadius: '16px',
              border: '1px solid #F0EFF8',
              backgroundColor: 'background.paper',
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 600,
                fontSize: '24px',
                lineHeight: '36px',
              }}
            >
              Add Comment
            </Typography>

            <Typography
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '24px',
                color: 'text.secondary',
              }}
            >
              Provide additional context or recommendations for this alert. Your comments will be logged for
              future reference and analysis.
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography
                sx={{
                  fontFamily: 'Inter Tight',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: 'text.primary',
                }}
              >
                Comments
              </Typography>
              <TextField
                label="Write here"
                multiline
                rows={4}
                value={alertComment}
                onChange={(e) => setAlertComment(e.target.value)}
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  sx: {
                    fontFamily: 'Inter Tight',
                    fontWeight: 400,
                  },
                }}
                InputProps={{
                  sx: {
                    fontFamily: 'Inter Tight',
                    fontWeight: 400,
                  },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
              <Button
                variant="outlined"
                onClick={handleClose}
                sx={{
                  fontFamily: 'Inter Tight',
                  fontWeight: 500,
                  textTransform: 'none',
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => saveComment()}
                sx={{
                  fontFamily: 'Inter Tight',
                  fontWeight: 500,
                  textTransform: 'none',
                  ml: 'auto',
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
        <ShareFootageModal
          open={openEmailModal}
          onClose={handleEmailModalClose}
          existingVideos={videos}
          emailConfig={{
            endpoint: API_ENDPOINTS.alarm.SHARE_ALERT_DETAILS_EMAIL,
            payload: {
              deviceId: alert?.device_id,
              warningSortKey: alert?.warningSortKey,
            },
          }}
          onEmailSent={() => {
            // setOpenEmailModal(false);
          }}
          onVideoCopied={() => {
            setOpenEmailModal(false);
          }}
        />
        <AlertToast
          message={alertMessage}
          type={alertType}
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
      <Dialog
        open={driverDialogOpen}
        onClose={driverDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Driver not associated with this particular alert
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={driverDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VehicleAlertDetail;
